export const getLogoByDomain = () => {
    const domainLogoMapping = {
        'aura444.us': '/logos/logo.png',
        'aura444.me': '/logos/aura444.png',
        'ptsexch.in': '/logos/ptsexch.png',
        'master444.bet': '/logos/master444.png',
        'aura-444.com': '/logos/logo.png',
    };

    // Get the current domain
    const currentDomain = window.location.hostname;

    // Return the corresponding logo or a default one
    return domainLogoMapping[currentDomain] || '/logos/logo.png';
};
